import { Typography } from "@mui/material";
import appleStore from "../../../../assets/images/app-store.png";
import googlePlay from "../../../../assets/images/google-play.png";

interface CallToActionSectionProps {
  buttonClickHandler: () => void;
}

export default function CallToActionSection({ buttonClickHandler }: CallToActionSectionProps) {
  return (
    <div className="call-to-action ">
      <div className="custom-container d-flex items-center width-100">
        <div className="call-to-action-content d-flex items-center flex-column justify-center">
          <Typography variant="h2">
            Streamline Your Lottery Management Today!
          </Typography>
          <Typography style={{ maxWidth: '830px' }}>
            Simplify your daily reconciliation, track performance, and stay audit-ready anytime, anywhere.
            Download the LottoReco app now on the App Store or Google Play and experience the difference.
          </Typography>

          <div className="d-flex items-center gap-8 flex-wrap justify-center">
            <img src={appleStore} alt="apple store" style={{ width: '186px', cursor: 'pointer' }} onClick={() => window.open('https://apps.apple.com/app/id6744914917')} />
            <img src={googlePlay} alt="google play" style={{ width: '186px', cursor: 'pointer' }} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.sof.lottoreco')} />
          </div>
        </div>
      </div>
    </div>
  );
}
